<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>Trhové ceny - Futures</h2>
      </div>
      <div>
        <b-card body-class="py-0 px-0" class="border-0 mb-0">
          <b-nav class="nav-base">
            <b-nav-item
              exact
              :to="{ name: 'mpFutures', query: { period: 'year' } }"
            >
              Ročné
            </b-nav-item>
            <b-nav-item
              exact
              :to="{ name: 'mpFutures', query: { period: 'quarter' } }"
            >
              Štvrťročné
            </b-nav-item>
            <b-nav-item
              exact
              :to="{ name: 'mpFutures', query: { period: 'month' } }"
            >
              Mesačné
            </b-nav-item>
          </b-nav>
        </b-card>
      </div>
      <div class="form-inline ml-3">
        <label class="mr-1">Dátum:</label>
        <date-picker
          v-model="date"
          :ranges="false"
          class="flex-grow-1 daterange-sm"
          opens="right"
          @update="changeDate"
        />
      </div>
      <b-btn class="ml-1" variant="secondary" @click="exportPower">
        <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
        Exportovať
      </b-btn>
    </div>
    <div class="h-100" style="min-height: 1px">
      <b-overlay class="h-100" :show="loading" :blur="null" opacity="0">
        <transition name="fadeDownShort" mode="out-in">
          <div v-if="!loading" v-bar class="bar-out">
            <div>
              <b-row class="my-2">
                <b-col md="6">
                  <Chart
                    title="Elektrina"
                    subtitle="EEX-PXE SLOVAKIAN POWER FUTURES"
                    :data="chartData.power"
                  />
                </b-col>
                <b-col md="6">
                  <Chart
                    title="Plyn"
                    subtitle="EEX THE NATURAL GAS FUTURES"
                    :data="chartData.gas"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </transition>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
import moment from 'moment'
import energyMarketService from '@/services/api/energyMarketService.js'
import Chart from './Chart.vue'
import DatePicker from '@/components/inputs/DatePicker.vue'
import { groupBy, map, mapValues } from 'lodash'

export default {
  components: { Chart, DatePicker },
  data() {
    return {
      loading: false,
      futures: [],
      data: {},
      date: {
        ge: moment().startOf('year').format('YYYY-MM-DD'),
        lt: moment().format('YYYY-MM-DD'),
      },
    }
  },
  computed: {
    chartData() {
      return mapValues(this.data, (type) =>
        mapValues(type, (future) => {
          return map(future, (i) => ({
            x: this.$moment(i.tradeDate).valueOf(),
            y: i.settlementPrice,
          }))
        }),
      )
    },
  },
  watch: {
    '$route.query.period'() {
      this.fetchData()
    },
  },
  mounted() {
    if (!Object.keys(this.$route.query).length) {
      this.$router.replace({ name: 'marketPrices', query: { period: 'year' } })
    }
  },
  created() {
    if (Object.keys(this.$route.query).length) {
      this.fetchData()
    }
  },
  methods: {
    changeDate() {
      this.fetchData(true)
    },
    fetchData(silent = false) {
      this.loading = !silent
      energyMarketService.getActiveFutures().then((res) => {
        this.futures = res.data
      })
      energyMarketService
        .getFuturesData({
          'futures.period': this.$route.query.period,
          tradeDate: { ge: this.date.ge, le: this.date.lt },
        })
        .then((res) => {
          this.data = mapValues(groupBy(res.data, 'futures.type'), (i) => {
            return groupBy(i, 'futures.future')
          })
          if (!silent) {
            this.loading = false
          }
        })
    },
    exportPower() {
      energyMarketService
        .downloadExcelExport({
          tradeDateFrom: this.date.ge,
          tradeDateTo: this.date.lt,
        })
        .then((res) => {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
    exportGas() {},
  },
}
</script>
